import { Navigate, useLocation } from 'react-router-dom';
import ApiDeliveryTracking from './ApiDeliveryTracking';
import '../components/ConfirmDialog.css';
import './orderTracking.css';

/** A delivery is followed on InGo's API (`?delivery=<id>`); without one, the client's orders. */
export default function LiveTrackingPage() {
  const { search } = useLocation();
  const apiDeliveryId = new URLSearchParams(search).get('delivery');

  return apiDeliveryId ? <ApiDeliveryTracking id={apiDeliveryId} /> : <Navigate to="/orders" replace />;
}

